import React, { useCallback, useEffect } from "react";
import StepContainer from "processes/Booking/components/BookingModal/components/StepContainer/StepContainer";
import Button from "components/Button";
import { AdditionalInsuranceList } from "components/AdditionalInsuranceList";
import { TextItem } from "components/TextItem";
import {
  getTotalPrice,
  getTags,
  isNextStep,
  setInitialDefaultTags,
  setDefaultTags,
  hasExtraInsurance,
  getDefaultValues,
  resetDefaultValues
} from "components/AdditionalInsuranceList/utils";
import Typography from "components/Typography";
import { FormElementsBlock } from "components/form/FormElementsBlock";
import { useForm } from "react-hook-form";
import { ADD_INSURANCE_EXTRA_IDS, ADD_INSURANCE_LIST_MODES } from "components/AdditionalInsuranceList/constants";
import { convertCents } from "utils/convertCents";
import classes from "./AdditionalInsurance.module.css";

const AdditionalInsurance = ({
  hasScrollShadow,
  handleNextStep,
  addInsuranceList = {},
  selectedPackagesAdditionalInsurance,
  setSelectedPackagesAdditionalInsurance,
  additionalInsuranceListLoading,
  isRefetchRentalPaymentModalDataLoading,
  setError,
  setIsInterruptionVisible,
  isClearTii,
  setIsClearTii,
  tiiDefaultTags,
  setTiiDefaultTags
}) => {

  const form_tags = getTags(addInsuranceList);

  const {
    control,
    handleSubmit,
    setError: formSetError,
    clearErrors,
    reset,
    getValues,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: { ...getDefaultValues(form_tags), ...tiiDefaultTags },
    shouldUnregister: false
  });

  const isSwitchChecked = selectedPackagesAdditionalInsurance?.insurancesIds?.includes(ADD_INSURANCE_EXTRA_IDS.INSURANCE_ID);

  const onNextStep = useCallback(() => {
    if (isNextStep(selectedPackagesAdditionalInsurance, addInsuranceList)) {
      setTiiDefaultTags(setDefaultTags(getValues()));
      setIsInterruptionVisible(hasExtraInsurance(selectedPackagesAdditionalInsurance));
      handleNextStep();
    } else {
      setError("Error Insurance");
    }
  }, [selectedPackagesAdditionalInsurance, addInsuranceList, getValues, setTiiDefaultTags, setIsInterruptionVisible, handleNextStep, setError]);

  useEffect(() => {
    if (isClearTii) {
      setIsClearTii(false);
      setTiiDefaultTags(setInitialDefaultTags());
      reset(resetDefaultValues(getValues()));
    }
  }, [getValues, isClearTii, reset, setIsClearTii, setTiiDefaultTags, setValue]);

  if (additionalInsuranceListLoading || isRefetchRentalPaymentModalDataLoading) return null;

  const footer = (
    <div className={classes.footer}>
      <div>
        <Typography
          variant="body"
          size="l"
          className={classes.name}
        >
          <span className={classes.total}>Total: </span>
          <span className="">${convertCents(getTotalPrice(selectedPackagesAdditionalInsurance, addInsuranceList))}</span>
        </Typography>
      </div>

      <div className={classes.buttons}>
        <Button
          onClick={handleSubmit(onNextStep)}
          label="Next"
          className="dddd"
        />
      </div>
    </div>
  );

  return (
    <StepContainer buttons={footer} hasScrollShadow={hasScrollShadow} buttonsContainerClassName={classes.buttonsContainerClassName}>
      <div className="mt-12">
        <div className="mb-24 mb-m-32 mb-l-24">
          <TextItem plainStyle={classes.descPlainStyle} data={addInsuranceList?.description} />
        </div>
        <AdditionalInsuranceList
          insurances={addInsuranceList?.insurances}
          selectedPackages={selectedPackagesAdditionalInsurance}
          setSelectedPackages={setSelectedPackagesAdditionalInsurance}
          mode={ADD_INSURANCE_LIST_MODES.USING}
        />

        {isSwitchChecked && (
          <div className="mt-16 mt-m-20">
            <FormElementsBlock
              form_header={addInsuranceList?.form_header}
              form_footer={addInsuranceList?.form_footer}
              form_elements={addInsuranceList?.form_elements}
              form_tags={form_tags}
              formParams={{
                control,
                handleSubmit,
                setError: formSetError,
                clearErrors,
                reset,
                getValues,
                errors
              }}
            />
          </div>
        )}
      </div>
    </StepContainer>
  );
};

export default AdditionalInsurance;
